<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b] "> Option Modification</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Option Modification / Division / Office</p>{{  }}
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5">
            <h1 class="text-[#24723b] font-semibold text-lg">Search/Edit Division or Office Portal</h1>
            <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Division</button>
        </div>
        <div class="papsi-container h-[300px]overflow-auto mt-3">
            <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" :header="header" :column="column" :info="info" :EButton="true" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton"/>
            </div>
        </div>
    </div>

    <div v-if="AddDivision">
        <div @click="AddDivision = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#12760A] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-semibold">{{ type }}</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Update Office/Division</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter New Office/Division" @input="division = division.toUpperCase()" v-model="division">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Update Office/Division Abbreviation</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Office/Division Abbreviation" @input="division = abbreviation.toUpperCase()" v-model="abbreviation">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Branch</p>
                    <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="branch_key" @change="filterRcCode">
                        <option selected disabled value="">Select Branch</option>
                        <option v-for="(branch, index) in $store.state.branch" :key="index" :value="branch.br_code">{{ branch.br_desc }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Responsibility Center Code</p>
                    <select :disabled="rc_select"  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="rc_code">
                        <option selected disabled value="">Select RC Code</option>
                        <option v-for="(branch, index) in rc_list" :key="index" :value="branch.rc_code.trim()">{{ branch.br_name.trim() }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Status</p>
                    <select class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="status">
                        <option value="1">ACTIVE</option>
                        <option value="0">INACTIVE</option>
                    </select>
                </div>
            <div class="pafcpic_footer flex gap-2 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-[#12760A] py-2  rounded-md w-[100px]"   v-if="Active === 'Add'" v-on:click="insertDivision">Add</button>
                <button class="text-sm text-white bg-[#12760A] py-2  rounded-md  w-[100px]"   v-if="Active === 'Update'" v-on:click="editDivision">Update</button>
                <button class="text-sm text-[#535353] bg-[#b3b1b1] py-2  rounded-md w-[100px]" v-on:click="AddDivision = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>

    <PromptComponent v-if="prompt" :header="promptheader" :header1="promptheader1" :success="success" @close="prompt = false"/>
    
</template>

<script>
import Div from "@/services/division";
import PromptComponent from "@/componentsv1/Prompt/PromptComponent.vue";
import TableControl from "../controls/TableControl/TableControl.vue"
import { defineComponent } from "vue";

export default defineComponent({
    components:{
        TableControl,
        PromptComponent,
    },
    data(){
        return{
            prompt: false,
            promptheader: null,
            promptheader1: null,
            success:false,
            type:'',
            info:           null,
            division:         '',
            abbreviation:     '',
            AddDivision:   false,
            TableView:      true,
            result:           '',
            Active:        'Add',
            EditID:           '',
            hash:             '',
            AddedDivision:    '',
            branch_key:       '',
            rc_list:null ,
            rc_code: '',
            status:'1',
            rc_select: true,
            header:[
                {
                    title:'Division No.'
                },
                {
                    title:'Division / Office'
                },
                {
                    title:'Abbreviation'
                },
                {
                    title:'Action'
                }
            ],
            column:[
                'division_code',
                'division_description',
                'Abbreviation'
            ],
        }
    },
     mounted(){
        this.getDivision()  
     },
    methods:{
        EditButton(row){
            this.type         =     'UPDATE DIVISION'
            this.Active       =     'Update'
            this.AddDivision  =     true
            this.EditId       =     row.division_code
            this.division     =     row.division_description
            this.abbreviation =     row.Abbreviation
            this.status       =      row.status 
            if(row.rc_code != null)
            {
                const data = this.$store.state.rc_branch.find(branch => branch.rc_code.trim() === row.rc_code.trim())
                this.branch_key = data.br_code.trim()
                this.filterRcCode()
                this.rc_code = row.rc_code.trim()
            }
            else{
                this.rc_select  = true
                this.branch_key = ''
                this.rc_code    = ''
            }
        },
        filterRcCode(){
           this.rc_code = ''
           this.rc_select = false
           this.rc_list = this.$store.state.rc_branch.filter(branch => branch.br_code.trim() === this.branch_key)
        },
        async insertDivision(){
            let that = this
            this.$emit("showLoader")
            await Div.addDivision(that.division, that.abbreviation, that.rc_code, that.status).then(async function(){
                await that.getDivision()
                that.AddDivision   = false
                that.success       = true
                that.promptheader  = "Successsfully Added New Office/Division"
                that.promptheader1 = "To modify the Division, go to the Option Modification Module."
                that.prompt        =  true
            }).catch(function(error){
                that.success       =  false
                that.promptheader  = "Error"
                that.promptheader1 =  error.response.data.message
                that.prompt        =  true
            });
            this.$emit("hideLoader")
        },
         async editDivision(){
            let that = this
            this.$emit("showLoader")
            await Div.editDivision(that.EditId, that.division, that.abbreviation, that.rc_code, that.status).then(async function(){
                await that.getDivision()
                that.AddDivision   = false
                that.success       = true
                that.promptheader  = "Successsfully Modify Office/Division"
                that.promptheader1 = "To modify the Division, go to the Option Modification Module."
                that.prompt        =  true
            }).catch(function(error){
                that.success       =  false
                that.promptheader  = "Error"
                that.promptheader1 =  error.response.data.message
                that.prompt        =  true
            });
            this.$emit("hideLoader")
        },
        async getDivision(){
            this.$emit("showLoader")
            let that = this
            await Div.getDivision().then(function(response){
                that.$store.state.divisionList = response.data.data
                that.info          =  response.data.data
            }).catch(function(error){
                console.log(error)
            });
            this.$emit("hideLoader")
        },
        HideView(){
            this.type = 'ADD DIVISION'

            if (!this.TableView){
                this.TableView    =   true
                this.AddDivision  =  false
            }
            else
            {
                this.branch_key   = ''
                this.rc_code      = ''
                this.division     = ''
                this.abbreviation = ''
                this.AddDivision  = true
                this.Active       = 'Add'
            }
        },
    }
})

</script>




